<div
  *ngIf="!hideContent"
  id="not-found-container"
  class="flex-align-it-center flex-justify-center flex-direction-column"
>
  <h1 class="margin-bottom-px-50">404</h1>
  <h1 class="margin-bottom-px-10" i18n="@@page-not-found">PAGE NOT FOUND</h1>
  <h2 i18n="@@wrong-url">The requested URL was not found on this server</h2>
  <button
    mat-raised-button
    color="primary"
    i18n="@@not-found-redirect-dashboard"
    (click)="redirectTo()"
    *ngIf="isAuthenticated; else notAuth"
  >
    Go to dashboard
  </button>
  <ng-template #notAuth>
    <button
      mat-raised-button
      color="primary"
      i18n="@@not-found-redirect-login"
      (click)="redirectTo()"
    >
      Go to login
    </button>
  </ng-template>
</div>
